textarea {
  overflow-y: auto;
}

textarea::-webkit-scrollbar {
  width: 8px;
  background-color: transparent;
}

textarea::-webkit-scrollbar-track {
  background-color: transparent;
  margin: 24px 0;
}

textarea::-webkit-scrollbar-thumb {
  background-color: var(--sky-base);
  border-radius: 4px;
  border: 2px solid transparent;
  background-clip: padding-box;
  cursor: pointer;
}

textarea::-webkit-scrollbar-thumb:hover {
  background-color: var(--sky-dark);
}

